<template>
  <div class="additional-info container">
    <div>
      <span>Sunrise</span>
      <span>{{ timeSunrise }}</span>
    </div>
    <div>
      <span>Sunset</span>
      <span>{{ timeSunset }}</span>
    </div>
    <div>
      <span>Humidity</span>
      <span>{{currentWeather.main.humidity}}%</span>
    </div>
    <div>
      <span>Cloudness</span>
      <span>{{currentWeather.clouds.all}}%</span>
    </div>
    <div>
      <span>Wind</span>
      <span>{{Math.round(currentWeather.wind.speed)}}m/s</span>
    </div>
    <div>
      <span>Pressure</span>
      <span>{{currentWeather.main.pressure}} hpa</span>
    </div>
  </div>
  
</template>

<script>
export default {
  name:"AdditionalInfo",
  props: ["currentWeather"],
  data() {
        return {
            date: null,
            h: null,
            m: null,
            timeSunrise: null,
            timeSunset: null,
            utc: null,
            offset: null,
            hb: null,
            mb: null,
            utcb: null,
            offsetb: null,

        };
    },
     created() {
    this.showDateSunrise();
    this.showDateSunset();
  },
    methods: {
        goToWeather() {
           this.$router.push({name: "Weather", params: { city: this.city.city }});
        },
        showDateSunrise() {
            this.offset = (this.currentWeather.timezone) * 1000;
            this.date = new Date((this.currentWeather.sys.sunrise * 1000)+ this.offset);
            this.h = this.date.getUTCHours();
            this.m = this.date.getUTCMinutes();
            if(this.h < 10) { this.h = "0" + this.h }
            if(this.m < 10) { this.m = "0" + this.m }
            this.timeSunrise = this.h + 'h' + this.m
            return this.timeSunrise
        },
        showDateSunset() {
            this.offsetb = (this.currentWeather.timezone * 1000);
            this.dateb = new Date((this.currentWeather.sys.sunset * 1000) + this.offsetb);
            this.hb = this.dateb.getUTCHours();
            this.mb = this.dateb.getUTCMinutes();
            if(this.hb < 10) { this.hb = "0" + this.hb }
            if(this.mb < 10) { this.mb = "0" + this.mb }
            this.timeSunset = this.hb + 'h' + this.mb
            return this.timeSunset
        },
}   
}
</script>

<style lang="scss" scoped>

.additional-info {
  padding: 30px 20px;
  display: flex;
  flex-wrap: wrap;
  color: white;
  
  > div {
    display: flex;
    flex-direction: column;
    flex-basis: 50%;
    margin-bottom: 20px;
    
    span:nth-child(1) {
      font-size: 12px;
      margin-bottom: 8px;
    }
    
     span:nth-child(2) {
      font-weight: 600;
    }
  }
  
  div:nth-child(5), div:nth-child(6) {
    margin-bottom: 0;
  }
}
</style>
